import { createUseStyles } from "react-jss"
import { textSize,boldFont, color} from '@portal/kit/pkg/styles'

export default createUseStyles(theme => ({
  tableInvoicesHeader: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid #f4f4f4`,
    ...textSize(14, 32),
    ...boldFont(),
    '& div': {
      '&:first-child': {
        width: '30%'
      },
      '&:nth-child(2)': {
        display: 'flex',
        justifyContent: 'center',
        width: '35%'
      },
      '&:nth-child(3)': {
        display: 'flex',
        justifyContent: 'flex-end',
        flexGrow: 1
      },
      '&:last-child': {
         width: 40
      }
    }
  },
  tableInvoicesRow: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid #f4f4f4`,
    ...textSize(14, 32),
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  tableInvoicesNum: {
    width: '30%'
  },
  tableInvoicesDate: {
    display: 'flex',
    justifyContent: 'center',
    width: '35%'
  },
  tableInvoicesTotal: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexGrow: 1
  },
  tableInvoicesAction: {
    display: 'flex',
    width: 40,
    justifyContent: 'flex-end',
    '&:hover':{
      cursor: 'pointer'
    }
  },
  tableInvoiceDownload: {
    padding: '4px 3px 4px 21px', // 40x40 square
    backgroundColor: '#ffffff',
    fontSize: 16,
    ...color('boxIcon')
  }
}))
